import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const helpTextParagraphs = [
    `Clicking on a row in the table will cause that row to become highlighted in 
    blue, and a new orange row will be inserted immediately below the blue row. 
    That orange row has values that can be edited (double-click a value to edit), 
    and changing those values will cause the calculated inventory allocations in 
    the blue row to update accordingly.`
    ,
    `Values in the orange row can be set to TRUE, FALSE, or a number between 0 and 100, 
    inclusive. TRUE indicates that available inventory will be evenly divided amongst 
    customers with a value of TRUE. FALSE indicates that inventory for that SKU will 
    not be sent to that customer at all. A numeric value indicates the percentage of 
    total inventory that should be sent to that customer. If numeric and TRUE values 
    are mixed within a single SKU, the numeric values will take precedence, and whatever 
    inventory remains will be divided evenly amongst the customers with an allocation 
    of TRUE.`
    ,
    `Don't forget to click the SAVE button after making changes, or unsaved updates will 
    be lost. If you have any questions, please contact Alex Fridman or Tim Sweeney.`
];


const InventoryAllocatorHelpPopup = props => {
    return (
        <Dialog open={props.displayHelpModal} onClose={() => props.setDisplayHelpModal(false)}>
            <DialogTitle>Inventory allocator help</DialogTitle>
            <DialogContent>{helpTextParagraphs.map(paragraph => {
                return <><DialogContentText>{paragraph}</DialogContentText><br /></>;
            })}</DialogContent>
            <DialogActions>
                <Button onClick={() => props.setDisplayHelpModal(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default InventoryAllocatorHelpPopup;